import { styled } from '@mui/material/styles';

export const LinkText = styled('a')(() => ({
	color: 'inherit',
	textDecoration: 'underline',
	cursor: 'pointer',
}));
